import React from 'react';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import { WalletResponseModel } from 'models/wallet';
import { isPhone, isTablet } from 'utils/commonUtils';
import { useAppSelector } from 'app/hooks';
import { platformStates } from 'redux/platformSlice';
import { formatAmountV2, formatMoney, formatMoneyWithoutTrunc } from 'utils/formatAmount';

interface UserWalletsProps {}

const UserWallets: React.FunctionComponent<UserWalletsProps> = () => {
  const { userWallets } = useHandleGetWallets();
  const platform = useAppSelector(platformStates);

  const renderWallet = (wallet: WalletResponseModel) => {
    return (
      <div key={`user-wallet-${wallet.id}`} className="flex gap-3 w-full items-center">
        <div
          className={`flex items-center gap-3 ${
            !isPhone(platform) && !isTablet(platform) && 'min-width-160'
          }`}
        >
          <img src={wallet.coin.image} width={30} height={30} alt="coin image" />
          {!isPhone(platform) && !isTablet(platform) && (
            <span className="primary-text-color font-bold">{wallet.coin.name}:</span>
          )}
        </div>
        <span className="primary-text-color font-bold">
          {formatAmountV2(
            wallet.balance,
            wallet.coin.symbol === 'USD' || wallet.coin.symbol === '$TBET' ? 2 : 8,
          )}{' '}
          {wallet.coin.symbol}{' '}
          {wallet.coin.symbol !== 'USD' &&
            wallet.balance !== '0' &&
            `(${formatMoneyWithoutTrunc(Number(wallet.balance) * Number(wallet.rate))})`}
        </span>
      </div>
    );
  };

  return (
    <div className="payment-methods primary-text-color items-center-important">
      {userWallets.filter((wallet) => wallet.coin.symbol !== 'USD').map(renderWallet)}
    </div>
  );
};

export default UserWallets;
